import { initializeIcons } from "@fluentui/react";
import React from "react";
import ReactDOM from "react-dom";
import { AppRouter } from "./Components/AppRouter";
import "./index.css";

initializeIcons();

ReactDOM.render(
  <React.StrictMode>
    <AppRouter />
  </React.StrictMode>,
  document.getElementById("root")
);
